// @flow
import Loading from 'components/Loading'
import ResourceFill from 'components/ResourceFill'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { ZentakeContext } from 'utils/ZentakeContext'

import FormClientFooter from '@/components/FormCustomer/FormClientFooter'
import useSearchParams from '@/hooks/useSearchParams'
import cn from '@/utils/tailwind/cn'

import { useLoadPreviewForm } from '../../queries/preview_form/useLoadPreviewForm'

const DEFAULT_DATA = {
  preview: {
    id: 'session',
    isSubmitted: false,
    responses: [],
  },
}
function PreviewForm(): React.Node {
  const searchParams = useSearchParams()
  const isShowFooter = searchParams.get('show_footer') === 'true'
  const params = useParams()

  const formId = params?.resourceId

  const { teamDetails, privateFetchInsuranceCompanies } =
    React.useContext(ZentakeContext)

  const { data: sessionsRequest, isLoading } = useLoadPreviewForm(
    formId,
    teamDetails,
    {
      enabled: Boolean(teamDetails),
    }
  )

  const sessions = isLoading ? DEFAULT_DATA : sessionsRequest

  React.useEffect(() => {
    privateFetchInsuranceCompanies()
  }, [privateFetchInsuranceCompanies])

  if (isLoading) return <Loading />

  return (
    <div
      className={cn('w-full', {
        'pb-12': isShowFooter,
      })}
    >
      <ResourceFill
        mode="preview"
        sessionId="preview"
        sessions={sessions}
        setSessions={() => undefined}
      />
      {isShowFooter ? (
        <FormClientFooter
          currentStep={null}
          onSaveEditLater={() => undefined}
          onSubmit={() => undefined}
        />
      ) : null}
    </div>
  )
}

export default PreviewForm
